module.exports = __webpack_public_path__ + "static/04-3ac253c6832dd289d69e1e8becc55569.jpg";